import { render, staticRenderFns } from "./CurrentReservation.vue?vue&type=template&id=02c896c4&scoped=true"
import script from "./CurrentReservation.vue?vue&type=script&lang=js"
export * from "./CurrentReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c896c4",
  null
  
)

export default component.exports